import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const headerFooterApi = {
  getHeaderFooters: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.HEADER_FOOTERS}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching header/footers:', error);
      throw error;
    }
  },

  getHeaderFooterByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.HEADER_FOOTERS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching header/footer ${identifier}:`, error);
      throw error;
    }
  },

  createHeaderFooter: async (headerFooterData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.HEADER_FOOTERS}`, headerFooterData);
      return response.data;
    } catch (error) {
      console.error('Error creating header/footer:', error);
      throw error;
    }
  },

  updateHeaderFooter: async (identifier, headerFooterData) => {
    try {
      headerFooterData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.HEADER_FOOTERS}/${identifier}`, headerFooterData);
      return response.data;
    } catch (error) {
      console.error(`Error updating header/footer ${identifier}:`, error);
      throw error;
    }
  },

  trashHeaderFooter: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.HEADER_FOOTERS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing header/footer ${identifier}:`, error);
      throw error;
    }
  },

  restoreHeaderFooter: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.HEADER_FOOTERS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring header/footer ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteHeaderFooter: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.HEADER_FOOTERS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting header/footer ${identifier}:`, error);
      throw error;
    }
  },
};

export default headerFooterApi;